// frontend/src/components/vehicle/VehicleCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaTachometerAlt, FaCog, FaRocket } from 'react-icons/fa';
import helpers from '../../utils/helpers';
import SaveButton from '../common/SaveButton';
import CompareButton from '../common/CompareButton';

function VehicleCard({ vehicle }) {
  const mainImage = vehicle.images?.front || Object.values(vehicle.images || {})[0] || 'https://via.placeholder.com/400x300?text=No+Image';
  const isPromoted = vehicle.is_promoted && new Date(vehicle.promoted_until) > new Date();

  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full group relative w-full ${isPromoted ? 'border-2 border-red-500 ring-2 ring-red-100' : ''}`}>
      
      {/* Save Button */}
      <div className="absolute top-2 right-2 z-10">
        <SaveButton itemId={vehicle.id} itemType="vehicle" />
      </div>

      {/* Compare Button */}
      <div className="absolute top-2 right-12 z-10">
        <CompareButton vehicle={vehicle} />
      </div>

      <Link to={`/vehicles/${vehicle.id}`} className="relative h-48 bg-gray-200 overflow-hidden block">
        <img 
          src={mainImage} 
          alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded uppercase font-semibold">
          {vehicle.condition.replace('_', ' ')}
        </div>
        
        {/* BOOST BADGE */}
        {isPromoted && (
            <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded font-bold flex items-center gap-1 shadow-md animate-pulse">
                <FaRocket size={10} /> FEATURED
            </div>
        )}

        <div className="absolute bottom-2 right-2 bg-primary text-white text-xs px-2 py-1 rounded font-bold">
          {helpers.formatCurrency(vehicle.price, 'NGN')}
        </div>
      </Link>

      <div className="p-4 flex-grow flex flex-col">
        <Link to={`/vehicles/${vehicle.id}`} className="block mb-2">
          <h3 className="text-lg font-bold text-gray-800 hover:text-primary transition-colors line-clamp-1 break-words">
            {vehicle.year} {vehicle.make} {vehicle.model}
          </h3>
        </Link>

        <div className="flex items-center text-gray-500 text-sm mb-3">
          <FaMapMarkerAlt className="mr-1 text-primary flex-shrink-0" />
          <span className="truncate">{vehicle.location_lga}, {vehicle.location_state}</span>
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mt-auto border-t pt-3">
          <div className="flex items-center truncate">
            <FaTachometerAlt className="mr-1.5 text-gray-400 flex-shrink-0" />
            <span className="truncate">{vehicle.mileage.toLocaleString()} km</span>
          </div>
          <div className="flex items-center truncate">
            <FaCog className="mr-1.5 text-gray-400 flex-shrink-0" />
            <span className="capitalize truncate">{vehicle.transmission}</span>
          </div>
        </div>
        
        <Link 
          to={`/vehicles/${vehicle.id}`}
          className="mt-4 w-full block text-center bg-gray-100 hover:bg-primary hover:text-white text-gray-800 font-semibold py-2 rounded transition duration-300 text-sm"
        >
          View Details
        </Link>
      </div>
    </div>
  );
}

export default VehicleCard;